if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();

        this.querySelectorAll('video').forEach((video) => {
          video.pause();
          video.currentTime = 0;
        });

        document.querySelectorAll('div[data-thumbnail] video').forEach((video) => {
          video.muted = true;
          video.playsInline = true;
          video.autoplay = true;

          video.play().catch((err) => {
            console.debug('Thumbnail video autoplay prevented:', err);
          });
        });
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });

        const activeMedia = this.querySelector(
          `[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`
        );
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }

        const modalVideo = activeMedia.querySelector('video');
        if (modalVideo) {
          modalVideo.muted = true;
          modalVideo.playsInline = true;
          modalVideo.autoplay = true;
          modalVideo.play().catch((err) => {
            console.debug('Modal video autoplay prevented:', err);
          });
        }
      }
    }
  );
}
